import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response, ResponseContentType} from '@angular/http';
import {Company} from 'classes/company';
import {Observable} from 'rxjs/Observable';
import {TargetGroup} from 'shared/models/target-groups/target-group';
import {Content} from 'shared/models/contents/content';

import {environment} from 'environment';

@Injectable()
export class ExportRepository {

  constructor(private http: Http) { }

  public getDailyExport(from: string, to: string, filterCompanies: Array<string>, filterTargetGroups: Array<string>): Observable<Blob> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      responseType: ResponseContentType.Blob,
    });

    const companyFilter: string = JSON.stringify(filterCompanies);
    const targetGroupFiter: string = JSON.stringify(filterTargetGroups);

    return this.http.get(`${environment.dailyExport}?from=${from}&to=${to}&companies=${companyFilter}&targetGroups=${targetGroupFiter}`, options)
            .map((response: Response) => {
              return response.blob();
            });
  }

  public getDialogsExport(from: string, to: string, filterCompanies: Array<string>, filterTargetGroups: Array<string>): Observable<Blob> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      responseType: ResponseContentType.Blob,
    });

    const companyFilter: string = JSON.stringify(filterCompanies);
    const targetGroupFiter: string = JSON.stringify(filterTargetGroups);

    return this.http.get(`${environment.dialogsExport}?from=${from}&to=${to}&companies=${companyFilter}&targetGroups=${targetGroupFiter}`, options)
            .map((response: Response) => {
              return response.blob();
            });
  }

  public getQuestionsExport(from: string, to: string, filterCompanies: Array<string>, filterTargetGroups: Array<string>): Observable<Blob> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      responseType: ResponseContentType.Blob,
    });

    const companyFilter: string = JSON.stringify(filterCompanies);
    const targetGroupFiter: string = JSON.stringify(filterTargetGroups);

    return this.http.get(`${environment.questionsExport}?from=${from}&to=${to}&companies=${companyFilter}&targetGroups=${targetGroupFiter}`, options)
      .map((response: Response) => {
        return response.blob();
      });
  }

  public getTiplistsExport(from: string, to: string, filterCompanies: Array<string>, filterTargetGroups: Array<string>): Observable<Blob> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      responseType: ResponseContentType.Blob,
    });

    const companyFilter: string = JSON.stringify(filterCompanies);
    const targetGroupFiter: string = JSON.stringify(filterTargetGroups);

    return this.http.get(`${environment.tiplistsExport}?from=${from}&to=${to}&companies=${companyFilter}&targetGroups=${targetGroupFiter}`, options)
      .map((response: Response) => {
        return response.blob();
      });
  }

  public getContentsExport(from: string, to: string, filterCompanies: Array<string>, filterTargetGroups: Array<string>, filterContents: Array<string>): Observable<Blob> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      responseType: ResponseContentType.Blob,
    });

    const companyFilter: string = JSON.stringify(filterCompanies);
    const targetGroupFiter: string = JSON.stringify(filterTargetGroups);
    const contentFiter: string = JSON.stringify(filterContents);

    return this.http.get(`${environment.contentsExport}?from=${from}&to=${to}&companies=${companyFilter}&targetGroups=${targetGroupFiter}&contents=${contentFiter}`, options)
      .map((response: Response) => {
        return response.blob();
      });
  }

  public getEpisodesExport(from: string, to: string, filterCompanies: Array<string>, filterTargetGroups: Array<string>): Observable<Blob> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      responseType: ResponseContentType.Blob,
    });

    const companyFilter: string = JSON.stringify(filterCompanies);
    const targetGroupFiter: string = JSON.stringify(filterTargetGroups);

    return this.http.get(`${environment.episodesExport}?from=${from}&to=${to}&companies=${companyFilter}&targetGroups=${targetGroupFiter}`, options)
      .map((response: Response) => {
        return response.blob();
      });
  }

  public getAllCompanies(): Observable<Array<Company>> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.get(`${environment.targetGroups.companies}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.targetGroups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllContents(): Observable<Array<Content>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.contents}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/export/repositories/export.repository.ts